// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2BAd4","title":"Info_title__2OO-F","links":"Info_links__33qSQ","link":"Info_link__17rgL","logo":"Info_logo__2EK46"};